export const signOutEndpoint = () => '/berths/auth/sign_out' as const
